import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'

import type { QueryClient } from '@tanstack/react-query'

import Providers from '@components/providers'

import type { trpcClient } from '@/lib/trpc'

export type RouterContext = {
  queryClient: QueryClient
  trpcClient: typeof trpcClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFound
})

function RootComponent() {
  return (
    <Providers direction='ltr'>
      <Outlet />
    </Providers>
  )
}

function NotFound() {
  return (
    <div className='flex flex-col items-center justify-center gap-2 min-bs-full flex-auto'>
      <h1 className='text-8xl font-medium'>404</h1>
      <p className='text-textSecondary'>Página não encontrada.</p>
    </div>
  )
}
